export const SET_CATEGORY = "SET_CATEGORY";
export const GET_CATEGORY = "GET_CATEGORY";

export const EMAIL_EXISTS = "EMAIL_EXISTS";

export const  CATEGORY_SUCCESS = "CATEGORY_SUCCESS";

export const  ADMIN_CATEGORY_CRUD = "ADMIN_CATEGORY_CRUD"; 